//on key pressed down
export const ON_KEY_PRESSED_DOWN_SET_KEY = "ON_KEY_PRESSED_DOWN_SET_KEY";
export const ON_KEY_PRESSED_DOWN_SET_KEY_SUCCESS =
  "ON_KEY_PRESSED_DOWN_SET_KEY_SUCCESS";
export const ON_KEY_PRESSED_DOWN_SET_KEY_FAILURE =
  "ON_KEY_PRESSED_DOWN_SET_KEY_FAILURE";
